export default __webpack_public_path__ + "static/media/809.77711009.png";